// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yo3gZ","label":"styles_label__ahMxG","select":"styles_select__WE7aq"};